"use strict"
let Caf = require('caffeine-script-runtime');
Caf.defMod(module, () => {return require('./Art.ClassSystem');});
//# sourceMappingURL=index.js.map
